// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/admin';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  logout: path(ROOTS_AUTH, '/logout'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  getAccountName: path(ROOTS_AUTH, '/get-account-name'),
  verify: path(ROOTS_AUTH, '/verify')
};

// ----------------------------------------------------------------------

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    wallet: path(ROOTS_DASHBOARD, '/wallet'),
    product: path(ROOTS_DASHBOARD, '/product'),
    users: path(ROOTS_DASHBOARD, '/users'),
    branch: path(ROOTS_DASHBOARD, '/branch')
  },
  report: {
    root: path(ROOTS_DASHBOARD, '/report'),
    product: path(ROOTS_DASHBOARD, '/report/product'),
    productSummary: path(ROOTS_DASHBOARD, '/report/product-summary')
  },
  settings: {
    root: path(ROOTS_DASHBOARD, '/settings'),
    email: path(ROOTS_DASHBOARD, '/settings/email')
  },
  app: {
    root: path(ROOTS_DASHBOARD, '/app'),
    updatePassword: path(ROOTS_DASHBOARD, '/app/update-password'),
    updateTrxKey: path(ROOTS_DASHBOARD, '/app/update-transaction-key')
  },
  admin: {
    sendMessage: path(ROOTS_DASHBOARD, '/admin/send-message'),
    sendEmail: path(ROOTS_DASHBOARD, '/admin/send-email')
  }
};
